import React from "react";

const Card = ({ id, imgUrl, title, location }) => {
  return (
    <div
      key={id}
      className="relative flex justify-center overflow-hidden transition-transform duration-300 ease-in-out transform h-72 -z-10 hover:scale-105"
    >
      <div className="flex flex-col items-center justify-center max-w-6xl bg-white border rounded-lg shadow lg:w-full md:w-3/4 hover:border-theme-color md:flex-row md:max-w-xl border-slate-200 md:h-60">
        <img
          className="inline object-cover w-full h-auto p-4 mb-2 ml-2 mr-2 border md:w-2/5 md:rounded-none md:rounded-l-lg border-slate-200"
          src={imgUrl}
          alt="storeLogo"
        />
        <div className="flex flex-col items-start justify-between p-4 leading-normal md:w-3/5">
          <h5 className="mb-2 font-bold tracking-tight lg:text-xl text-md text-slate-700 md:text-2xl">
            {title}
          </h5>
          <p className="mb-3 text-sm font-normal text-gray-700 md:text-base dark:text-gray-400">
            {location}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Card;
